angular.module('TetherApp').controller('ListDataController', [
    '$window',
    'campaignService',
    'listService',
    function (
        $window,
        campaignService,
        listService
    ) {

        let self = this;
        self.campaigns = [];
        self.campaignList = [];
        self.list = {};
        self.list.name = '';
        self.list.campaign_ids = [];
        self.list.allow_multiple = false;
        self.errors = undefined;

        self.init = function (listId) {
            self.fetchList(listId);
            self.fetchCampaigns();
        }

        self.fetchCampaigns = function () {
            campaignService.list().then(onCampaignList, onError);
        };

        let onCampaignList = function (data) {
            self.campaigns = data;
        };

        self.addCampaign = function () {
            let index = -1;
            self.campaignList.forEach(function (campaign, i) {
                if (campaign.id == self.currentCampaign.id) {
                    index = i;
                }
            });
            // Check if campaign has already been added, if not add it
            if (index == -1) {
                self.campaignList.push(self.currentCampaign);
            }
        };

        self.removeCampaign = function (campaign) {
            let index = self.campaignList.indexOf(campaign);
            // Check if campaign exist and remove it
            if (index > -1) {
                self.campaignList.splice(index, 1);
            }
        };

        self.fetchList = function (listId) {
            listService.readList(listId)
                .then(onRead, onError);
        };

        let onRead = function (data) {
            self.list = data;
            self.list.campaign_ids = [];
            self.allowMultiple = data.type == 3;
            self.campaignList = data.campaigns;

            if (self.list.is_public == 1 || self.list.is_public == 'on') {
                self.list.is_public = true;
            } else {
                self.list.is_public = false;
            }
        };

        self.delete = function (callbackLoadList, callbackCloseModal, listId) {
            if ($window.confirm(self.deleteConfirmationText)) {
                self.onDeleteLoadList = function () { window.location = window.location; };
                self.onDeleteCloseModal = callbackCloseModal;
                listService.deleteList(listId)
                    .then(onDelete, onError);
            }
        };

        let onDelete = function (data) {
            self.onDeleteLoadList();
            self.onDeleteCloseModal();
        };

        self.edit = function (callback, listId) {
                self.onEditCallback = callback;
                self.campaignList.forEach(function (campaign) {
                    self.list.campaign_ids.push(campaign.id);
                });
                listService.editList(listId, self.list)
                    .then(onEdit, onError);
        };

        let onEdit = function (data) {
            self.onEditCallback();
        };

        let onError = function (response) {
            self.errors = response.data.errors;
        };
    }
]);
